/**
 * New style file — the Style File composer (garment Increment 1).
 *
 * @see prototype/garment/style-file.html — V1.1 baseline
 */
import { createFileRoute } from "@tanstack/react-router";
import { WorkspaceShell } from "../../../../features/workspace/index.ts";
import { StyleComposerPage } from "../../../../features/styles/index.ts";

export const Route = createFileRoute("/(workspace)/merchandising/styles/new")({
  component: NewStyleRoute,
});

function NewStyleRoute() {
  return (
    <WorkspaceShell
      breadcrumbs={[
        { label: "Merchandising", to: "/" },
        { label: "Style files", to: "/merchandising/styles" },
        { label: "New" },
      ]}
      contentClassName="max-w-none"
      viewportClassName="p-0 md:p-0"
    >
      <StyleComposerPage />
    </WorkspaceShell>
  );
}
